export enum LoadingStage {
  NOT_STARTED = 'NOT_STARTED',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
}

export enum LayoutVersion {
  MOBILE = 'mobile',
  DESKTOP = 'desktop'
}

export enum Placement {
  LEFT = 'left',
  RIGHT = 'right'
}

export enum InitializationState {
  NOT_INITIALIZED = 'not_initialized',
  LOADING = 'loading',
  INITIALIZED = 'initialized'
}

export enum SessionState {
  IDLE = 'idle',
  OPENING = 'opening',
  OPENED = 'opened',
  ERROR = 'error'
}

export enum MessageSource {
  INJECT = 'inject',
  WIDGET = 'widget'
}
